import icon1 from "../assets/icons/os1.svg";
import icon2 from "../assets/icons/os2.svg";
import icon3 from "../assets/icons/os3.svg";
import { findPageSection, unwrapSectionData } from "./aboutStartNewProjectSection";

export const fallbackOurSolution = {
  tag: "OUR SOLUTIONS",
  titleLine1: "Integrated Systems",
  titleLine2: "for Every",
  titleLine3: "Construction Need",
  description:
    "IRQGYP delivers integrated solutions across every stage of construction, the complete solution from foundations to final finishes.",
  moreDetailsText: "More Details",
  item1Title: "Exterior System",
  item1Description:
    "IRQGYP delivers advanced exterior solutions for durable, high-performance, weather-resistant architecture.",
  item1Link: "/solutiondetails/exterior-system",
  item2Title: "Interior Drywall System",
  item2Description:
    "IRQGYP Drywall System: lightweight, acoustic, moisture-resistant walls with integrated services.",
  item2Link: "/solutiondetails/interior-drywall-system",
  item3Title: "Ceiling System",
  item3Description:
    "High-performance ceiling systems designed for durability and aesthetic integration.",
  item3Link: "/solutiondetails/ceiling-system",
};

const itemFieldRegex = /^item(\d+)([a-zA-Z0-9_]+)$/i;

const CARD_ICONS = [icon1, icon2, icon3];

export const buildCardsFromContent = (content) => {
  const cardsMap = new Map();

  Object.entries(content || {}).forEach(([key, value]) => {
    const match = key.match(itemFieldRegex);
    if (!match) return;
    const index = Number(match[1]);
    const rawField = String(match[2] || "");
    const field = rawField.replace(/[_\s-]+/g, "").toLowerCase();
    if (!cardsMap.has(index)) cardsMap.set(index, {});
    cardsMap.get(index)[field] = value;
  });

  return Array.from(cardsMap.entries())
    .sort((a, b) => a[0] - b[0])
    .map(([index, fields]) => ({
      index,
      title: fields.title || "",
      description: fields.description || "",
      link: fields.link || "",
    }))
    .filter((card) => card.title || card.description || card.link);
};

export const hasOurSolutionSectionData = (section) => {
  if (!section || typeof section !== "object") return false;
  return Object.values(section).some((value) => {
    if (value === null || typeof value === "undefined") return false;
    if (typeof value === "string") return value.trim().length > 0;
    return true;
  });
};

export const getOurSolutionSectionFromHome = (homeContent) =>
  unwrapSectionData(findPageSection(homeContent, "oursolution"));

export const getOurSolutionDisplayCards = (content) => {
  const sectionContent = hasOurSolutionSectionData(content) ? content : fallbackOurSolution;
  const dynamicCards = buildCardsFromContent(sectionContent);

  if (dynamicCards.length) {
    return dynamicCards.map((card, idx) => ({
      key: card.link || `our-solution-${idx}`,
      title: card.title,
      description: card.description,
      link: card.link,
      icon: CARD_ICONS[idx] || icon1,
    }));
  }

  return [
    {
      key: fallbackOurSolution.item1Link,
      title: fallbackOurSolution.item1Title,
      description: fallbackOurSolution.item1Description,
      link: fallbackOurSolution.item1Link,
      icon: icon1,
    },
    {
      key: fallbackOurSolution.item2Link,
      title: fallbackOurSolution.item2Title,
      description: fallbackOurSolution.item2Description,
      link: fallbackOurSolution.item2Link,
      icon: icon2,
    },
    {
      key: fallbackOurSolution.item3Link,
      title: fallbackOurSolution.item3Title,
      description: fallbackOurSolution.item3Description,
      link: fallbackOurSolution.item3Link,
      icon: icon3,
    },
  ];
};
